module.exports = __webpack_public_path__ + "img/colors@2x.c9f0a10d.jpg";